export { default as IndexTableHeaderCell } from './IndexTableHeaderCell';
